import { signal } from "@preact/signals";
import { isFullyPaid } from "@orderman/shared";
import { startOrder, draft, resumeOrder, tablesConfig, tablesRestricted, tableAllowed } from "../state/store.js";
import { payableOf } from "../state/draft.js";

const tableInput = signal("");
const error = signal("");

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "⌫", "0", "OK"];

function press(k: string): void {
  error.value = "";
  if (k === "⌫") tableInput.value = tableInput.value.slice(0, -1);
  else if (k === "OK") {
    if (!tableInput.value) return;
    const label = `Tisch ${tableInput.value}`;
    if (!tableAllowed(label)) {
      error.value = `Tisch ${tableInput.value} ist nicht freigegeben.`;
      return;
    }
    startOrder(label);
    tableInput.value = "";
  } else if (tableInput.value.length < 4) {
    tableInput.value += k;
  }
}

/** Kurzbeschreibung der gültigen Bereiche (für den Hinweis). */
function rangeHint(): string {
  const rs = tablesConfig.value.ranges;
  if (rs.length === 0) return "";
  return rs.map((r) => (r.from === r.to ? `${r.from}` : `${r.from}–${r.to}`)).join(", ");
}

export function TablePad() {
  const extras = tablesConfig.value.extras;
  return (
    <div class="tablepad">
      {draft.value && !isFullyPaid(payableOf(draft.value)) && (
        <button class="resume" onClick={resumeOrder}>
          ‹ Weiter mit {draft.value.tableRef}
        </button>
      )}
      <div class="tablepad-title">Tisch wählen</div>
      <div class="tablepad-display">{tableInput.value || "—"}</div>
      {tablesRestricted.value && rangeHint() && (
        <div class="tablepad-hint">Gültig: {rangeHint()}</div>
      )}
      {error.value && <div class="tablepad-error">{error.value}</div>}
      <div class="keypad">
        {KEYS.map((k) => (
          <button
            key={k}
            class={`key ${k === "OK" ? "key-ok" : ""} ${k === "⌫" ? "key-del" : ""}`}
            onClick={() => press(k)}
          >
            {k}
          </button>
        ))}
      </div>
      {extras.length > 0 && (
        <div class="tablepad-extras">
          {extras.map((e) => (
            <button key={e} class="extra-btn" onClick={() => startOrder(e)}>
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
